$(document).ready(function () {
	$(document).on('scroll', function () {
		if ($('.events-list').length) {
			if (window.innerWidth < 1000) {
				// add fixed-top if the screen is at top of events list minus height of the search bar, 
				// which equals top of the screen being flush with top of the search bar
				var searchOffset = $('.events-list').offset().top - 150;
				var currentOffset = $(document).scrollTop();
				var goingDown = currentOffset > searchOffset;
				var goingUp = !goingDown;
				var isFixed = $('.event-search-mobile').hasClass('fixed-top');

				if (goingDown == true && isFixed == false) {
					$('.event-search-mobile').addClass('fixed-top');
				} else if (goingUp == true && isFixed == true) {
					$('.event-search-mobile').removeClass('fixed-top');
				}
			} else {
				var searchOffset = $('.events-list').offset().top;
				var currentOffset = $(document).scrollTop();
				var offsetlimit = $('.events-list').offset().top + $('.events-list').height() - $('.event-search').height() - 100;

				if ((currentOffset > searchOffset) && (currentOffset < offsetlimit)) {
					// additional 40px needed so that there's some whitespace between the sidebar and top of the screen
					var difference = currentOffset - searchOffset + 40;
					$('.event-search-desktop').css('top', difference + 'px');
				} else if (currentOffset < searchOffset) {
					$('.event-search-desktop').css('top', '0px');
				}
			}
		}
    });
});
